import React, { useState } from 'react';
import { arrayOf, bool, func, node, number, shape, string } from 'prop-types';
import { ExchangeCircle, Icon } from '@magalu/stereo-ui-icons';
import Button from '@magalu/stereo-ui/atoms/Button';
import Avatar from '@magalu/stereo-ui/molecules/Avatar';
import Carousel from '@magalu/stereo-ui/molecules/Carousel';
import Review from '@magalu/stereo-ui/molecules/Review';
import { SeeMore, ModalDetails, DescriptionBlock, ModalDetailsHeader, CloseButton, CaroulselBlock, ReviewContainer, Header, ReviewerName, ReviewWrapper, RotateButtonBlock } from './mobile-review-popup.styles';
import { reduceDescription, validateShortDescription } from '../../helpers';

const MobileReviewPopup = ({
  charLimit,
  children,
  closePopup,
  selectedMedia,
  review,
  changeCaroulsel,
  showRotateButton,
  onRotateImage
}) => {
  const [seeMore, setSeeMore] = useState(false);
  const {
    rating,
    description,
    userData
  } = review;
  const isShortDescription = validateShortDescription(description, charLimit);
  const reducedDescription = reduceDescription(description, charLimit);
  return /*#__PURE__*/React.createElement(ModalDetails, null, /*#__PURE__*/React.createElement(ModalDetailsHeader, null, /*#__PURE__*/React.createElement(CloseButton, {
    "data-testid": "close-popup",
    "aria-label": "fechar popup",
    onClick: closePopup
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "Close",
    color: "#FFF"
  }))), /*#__PURE__*/React.createElement(CaroulselBlock, null, /*#__PURE__*/React.createElement(Carousel, {
    auto: false,
    goTo: selectedMedia,
    verticalAlign: "center",
    onChange: changeCaroulsel
  }, children), /*#__PURE__*/React.createElement(RotateButtonBlock, {
    justifyContent: "center",
    alignItems: "center"
  }, showRotateButton && /*#__PURE__*/React.createElement(Button, {
    variation: "outline",
    size: "small",
    onClick: onRotateImage,
    startIcon: /*#__PURE__*/React.createElement(ExchangeCircle, {
      width: 20,
      height: 20
    }),
    centered: true
  }, "Girar imagem"))), /*#__PURE__*/React.createElement(ReviewContainer, {
    container: true
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Avatar, null), /*#__PURE__*/React.createElement(ReviewerName, null, userData.name), /*#__PURE__*/React.createElement(ReviewWrapper, null, /*#__PURE__*/React.createElement(Review, {
    score: rating
  }))), /*#__PURE__*/React.createElement(DescriptionBlock, {
    "data-testid": "review-description"
  }, seeMore || isShortDescription ? description : reducedDescription, "\xA0", !isShortDescription && /*#__PURE__*/React.createElement(SeeMore, {
    onClick: () => setSeeMore(!seeMore),
    role: "button"
  }, !seeMore ? 'ver mais' : 'ver menos'))));
};

process.env.NODE_ENV !== "production" ? MobileReviewPopup.propTypes = {
  charLimit: number,
  children: node,
  review: shape({
    rating: number,
    description: string,
    submissionDate: string,
    dimensionDefs: arrayOf(string),
    userData: shape({
      name: string
    })
  }),
  selectedMedia: number,
  closePopup: func,
  changeCaroulsel: func,
  showRotateButton: bool,
  onRotateImage: func
} : void 0;
MobileReviewPopup.defaultProps = {
  charLimit: 110,
  changeCaroulsel: () => 0
};
export default MobileReviewPopup;